import { z } from 'zod';
export var ToolChangeSource;
(function (ToolChangeSource) {
    ToolChangeSource["DASHBOARD"] = "dashboard";
    ToolChangeSource["API"] = "api";
    ToolChangeSource["SYSTEM"] = "system";
})(ToolChangeSource || (ToolChangeSource = {}));
export var ToolHistoryEntryKind;
(function (ToolHistoryEntryKind) {
    ToolHistoryEntryKind["CREATED"] = "created";
    ToolHistoryEntryKind["BASELINE"] = "baseline";
    ToolHistoryEntryKind["UPDATED"] = "updated";
})(ToolHistoryEntryKind || (ToolHistoryEntryKind = {}));
export const toolFieldChangeSchema = z.object({
    field: z.string(),
    before: z.string().nullable(),
    after: z.string().nullable(),
});
export const toolHistoryEntrySchema = z.object({
    id: z.string().uuid(),
    toolId: z.string().uuid(),
    partnerId: z.string().uuid(),
    source: z.nativeEnum(ToolChangeSource),
    userId: z.string().nullable(),
    userEmail: z.string().nullable(),
    createdAt: z.string(),
    changes: z.array(toolFieldChangeSchema),
    kind: z.nativeEnum(ToolHistoryEntryKind).optional(),
});
export const toolHistoryQuerySchema = z.object({
    cursor: z.string().uuid().optional(),
    limit: z.coerce.number().int().min(1).max(50).default(20),
});
export const toolHistoryPageSchema = z.object({
    entries: z.array(toolHistoryEntrySchema),
    nextCursor: z.string().uuid().nullable(),
});
//# sourceMappingURL=tool-history.js.map